<div *ngIf="isContentLoaderShown" class="content-loader-wrapper d-flex">
    <div class="text-center content-loader">
        <img src="../../../../assets/payment-loader.svg" class="content-loader-icon" alt="loader">
        <span class="d-block w-100">{{ 'payment.waiting_confirmation' | translate }}</span>
    </div>
</div>
